<section>
  <header class="w3-border-bottom w3-bottombar w3-border-theme-secondary">
    <div class="action-list-header w3-container">
      <div class="header-icon">
        @if (icon) {
          <i [ngClass]="icon" class="w3-large"></i>
        }
      </div>
      <div class="list-title text-bold w3-large upper-case">
        {{ name | translate }}
      </div>
      @if (action) {
        <button
          type="button"
          class="action-button no-transform w3-small"
          (click)="onActionClicked()"
        >
          <i class="w3-large" [ngClass]="action"></i>
        </button>
      }
    </div>
  </header>
  @if (items.length) {
    <ul class="action-list-items" [ngClass]="{ 'prefix-icon': !!icon }">
      @for (data of visibleItems; track data) {
        <li>
          <a
            [routerLink]="data.routerLink"
            routerLinkActive="action-list-item-active"
            ariaCurrentWhenActive="page"
            class="action-list-item no-transform"
            (click)="onItemClicked({ itemData: data })"
          >
            @if (!!data.type) {
              <div class="toolbar-icon">
                @if (data.type === 'company') {
                  <i class="fa-regular fa-building fa-lg"></i>
                } @else {
                  <app-list-type-icon
                    [type]="data.type"
                    [large]="false"
                  ></app-list-type-icon>
                }
              </div>
            }
            <div class="list-name">
              {{ data.name }}
            </div>
          </a>
        </li>
      }
    </ul>
    @if (cut && moreLink) {
      <a
        class="action-list-more"
        [routerLink]="moreLink.link"
        [queryParams]="moreLink.queryParams"
        (click)="moreClicked.emit()"
        >{{ moreLink.label | translate }}
        <i class="fa-solid fa-angle-right" aria-hidden="true"></i
      ></a>
    }
  } @else if (emptyText) {
    <p class="action-list-empty">{{ emptyText | translate }}</p>
  }
</section>
